<template>
<section data-anchor="home" :class="'hero is-' + ($route.path == '/' ? 'fullheight' : 'medium')">
    <div :class="['hero-body']">
        <div class="hero-bg" :style="bgstyle"></div>
        <div v-if="site_data.hero.content" class="container has-text-centered">
            <p class="subtitle is-5">{{site_data.hero.content.subtitle}}</p>
            <h2 class="title is-1">
                <span class="hero-title">{{site_data.hero.content.title}}</span>
                <span :class="['is-changeable', {'is-shown': show}]" v-if="current_intro">{{current_intro}}</span>
            </h2>
            <div class="content" v-html="site_data.hero.content.content"></div>
            <p class="content social" v-if="site_data.siteconfig.socials">
                <a :href="item.url" target="_blank" v-for="item in site_data.siteconfig.socials">
                    <span class="icon"><i :class="'fab fa-' + item.id"></i></span>
                </a>
            </p>
            <p class="action">
                <button @click.prevent="go_contact" class="button is-outlined is-white is-rounded">Contact Me</button>
            </p>
        </div>
    </div>
    <div class="hero-svg">
        <svg x="0px" y="0px" viewBox="0 186.5 1920 113.5">
            <polygon points="-30,300 355.167,210.5 1432.5,290 1920,198.5 1920,300"></polygon>
        </svg>
    </div>
</section>
</template>

<script>
export default {
    name        :   'Hero',
    props       :   ['site_data'],
    data()
    {
        return {
            cur_index: 0,
            show: false,
            offset: 0
        };
    },
    created()
    {
        this.$bus.$on('onWindowScroll', this.handle_scroll);
    },
    beforeDestory()
    {
        this.$bus.$off('onWindowScroll', this.handle_scroll);
    },
    mounted()
    {
        this.$nextTick().then(() => {
            // this.offset =   $(window).height() * -0.2;
            setTimeout(() => {
                this.show   =   true;
            }, 300);
        });
    },
    watch       :   {
        show(nv, ov)
        {
            this.start_ticking();
        }
    },
    computed    :   {
        current_intro()
        {
            if (this.site_data.hero.content &&
                this.site_data.hero.content.titles &&
                this.site_data.hero.content.titles.length) {
                return this.site_data.hero.content.titles[this.cur_index];
            }

            return null;
        },
        bgstyle()
        {
            return 'background-image: url(' + this.bg + '); -webkit-transform: translate(0, ' + this.offset + 'px); transform: translate(0, ' + this.offset + 'px);';
        },
        bg()
        {
            if (this.site_data && this.site_data.hero) {
                return this.site_data.hero.url;
            }

            return null;
        }
    },
    methods     :   {
        handle_scroll(offset)
        {
            this.offset =   offset * 0.5;
        },
        go_contact(e)
        {
            this.$bus.$emit('scrollTo', 'contact');
        },
        start_ticking()
        {
            if (this.site_data &&
                this.site_data.hero.content &&
                this.site_data.hero.content.titles &&
                this.site_data.hero.content.titles.length > 1) {

                setTimeout(() =>
                {
                    this.show   =   !this.show;
                    if (!this.show) {
                        setTimeout(() =>
                        {
                            if (this.cur_index < this.site_data.hero.content.titles.length - 1) {
                                this.cur_index++;
                            } else {
                                this.cur_index  =   0;
                            }
                        }, 1000);
                    }
                }, 1500);

            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/blocks/Hero.vue